import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import CommentIcon from "@mui/icons-material/Comment";
import type { EditableCallbackParams } from "ag-grid-community";
import { useEffect, useState } from "react";
import { EditWorkOrderModal } from "@/shared/work-orders-modals/components/modal-edit-work-order";
import { useSearchWorkOrderAttachments } from "@/shared/work-orders-modals/components/hooks/useSearchWOAttachaments";
import { ErrorModal } from "@dexteel/mesf-core";

type Props = {
	params: EditableCallbackParams;
	searchWorkOrders: Function;
};

export const WorkOrderCommentsColumnColumn = ({
	params,
	searchWorkOrders,
}: Props) => {
	const [openGridEditDialog, setOpenGridEditDialog] = useState<boolean>(false);
	const [attachmentsList, setAttachmentsList] = useState([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");
	const searchWorkOrderAttachments = useSearchWorkOrderAttachments({
		WorkOrderId: params.data?.WorkOrderId,
		setAttachmentsList,
		setIsLoading,
		setError,
	});
	useEffect(() => {
		if (openGridEditDialog) searchWorkOrderAttachments();
	}, [openGridEditDialog]);

	if (params.data.id !== -1) {
		return (
			<>
				<Grid2 container spacing={1} style={{ alignItems: "center" }}>
					{params.data?.Comments?.trim() && (
						<Grid2 size={{ md: 12, xs: 12 }}>
							<Button
								onClick={() => setOpenGridEditDialog(true)}
								fullWidth
								color="primary"
								style={{
									textDecoration: "none",
									fontWeight: 500,
									fontSize: "12px",
									borderRadius: "3px",
									marginRight: 8,
								}}
								title={`${(params.data?.Comments).substr(0, 50)}...`}
							>
								<CommentIcon />
							</Button>
						</Grid2>
					)}
				</Grid2>
				<EditWorkOrderModal
					show={openGridEditDialog}
					data={params.data as any}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							searchWorkOrders();
						}
						setOpenGridEditDialog(false);
					}}
				/>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	} else return <></>;
};
